
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 213 140"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#92B8B8","d":"M42.978.5h127v138h-127z"}}),_c('path',{attrs:{"fill":"#92B8B8","d":"M43.479 1h126.305v20.593H43.479z"}}),_c('rect',{attrs:{"width":"53.466","height":"4.753","x":"51.398","y":"8.92","fill":"#DFEAEA","rx":"2.376"}}),_c('path',{attrs:{"fill":"#fff","d":"M43.479 21.593h126V138h-126z"}}),_c('rect',{attrs:{"width":"30.109","height":"4.752","x":"51.398","y":"29.513","fill":"#D0DBDB","rx":"2.376"}}),_c('rect',{attrs:{"width":"53.496","height":"4.752","x":"51.398","y":"37.435","fill":"#EDF4F4","rx":"2.376"}}),_c('rect',{attrs:{"width":"53.496","height":"4.752","x":"108.062","y":"37.435","fill":"#DFEAEA","rx":"2.376"}}),_c('rect',{attrs:{"width":"52.266","height":"4.75","x":"51.398","y":"54.144","fill":"#BDCCCC","rx":"2.375"}}),_c('rect',{attrs:{"width":"110.16","height":"4.75","x":"51.398","y":"62.064","fill":"#EDF4F4","rx":"2.375"}}),_c('rect',{attrs:{"width":"110.16","height":"4.75","x":"51.398","y":"69.984","fill":"#DFEAEA","rx":"2.375"}}),_c('rect',{attrs:{"width":"34.607","height":"4.75","x":"51.398","y":"77.904","fill":"#EDF4F4","rx":"2.375"}}),_c('rect',{attrs:{"width":"34.607","height":"4.75","x":"89.176","y":"77.904","fill":"#DFEAEA","rx":"2.375"}}),_c('rect',{attrs:{"width":"34.607","height":"4.75","x":"126.951","y":"77.904","fill":"#EDF4F4","rx":"2.375"}}),_c('rect',{attrs:{"width":"59.465","height":"4.752","x":"51.398","y":"94.611","fill":"#D0DBDB","rx":"2.376"}}),_c('rect',{attrs:{"width":"110.16","height":"4.752","x":"51.398","y":"102.533","fill":"#EDF4F4","rx":"2.376"}}),_c('path',{attrs:{"fill":"#92B8B8","d":"M137.635 119.242h23.923v10.838h-23.923z"}})])
          )
        }
      }
    